const colors = {
    Black100 : '#000000',
    Black40: '#282828', /*not available in style guide*/
    White0 : '#ffffff',
    Grey02 : '#f9f9f9',
    Grey04 : '#f4f4f4',
    Grey08 : '#ebebeb',
    Grey14 : '#dbdbdb',
    Grey20 : '#cccccc',
    Grey40 : '#999999',
    Grey60 : '#666666',
    Grey70 : '#4a4d4e',
    Grey80 : '#333333',
    Grey84 : '#2a2a2a',
    Red70 : '#e60000',
    Red75 : '#bd0000',
    Red80 : '#990000',
    Red67 : '#ff0000',
    Teal51 : '#00b0ca',
    Teal65 : '#007c92',
    Teal75 : '#005765',
    Purple72 : '#5e2750',
    Purple53 : '#9c2aa0',
    Yellow50 : '#eb9700',
    Yellow40 : '#fecb00',
    Limegreen55 : '#a8b400',
    Green74 : '#428600',
    Black23: '#282828',
    Purple100: '#9C2AA0',
    
}

export default colors;